import React from 'react'

const AuthCoverSignin = () => {
    return (
        <>
            <div className="wrapper">
                <div className="section-authentication-cover">
                    <div className>
                        <div className="row g-0">
                            <div className="col-12 col-xl-7 col-xxl-8 auth-cover-left align-items-center justify-content-center d-none d-xl-flex">
                                <div className="card shadow-none bg-transparent shadow-none rounded-0 mb-0">
                                    <div className="card-body">
                                        <img src="images/login-images/login-cover.png" className="img-fluid auth-img-cover-login" width={650} alt />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-xl-5 col-xxl-4 auth-cover-right align-items-center justify-content-center">
                                <div className="card rounded-0 m-3 shadow-none bg-transparent mb-0">
                                    <div className="card-body p-sm-5">
                                        <div className>
                                            <div className="mb-3 text-center">
                                                <img src="images/logo-icon.png" width="auto" alt />
                                            </div>
                                            <div className="text-center mb-4">
                                                <h5 class="">RemoteRef Sporting Panel</h5>
                                                <p className="mb-0">Please log in to your account</p>
                                            </div>
                                            <div className="form-body">
                                                <form className="row g-3" id="jQueryValidationForm" method="post" action="/">
                                                    <div className="col-12">
                                                        <label htmlFor="inputEmailAddress" className="form-label">Email</label>
                                                        <input type="email" name="email" className="form-control" id="inputEmailAddress" placeholder="jhon@example.com" required />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="inputChoosePassword" className="form-label">Password</label>
                                                        <div className="input-group" id="show_hide_password">
                                                            <input type="password" className="form-control border-end-0" defaultValue placeholder="Enter Password" required />
                                                            <a href="" className="input-group-text bg-transparent" id="togglePassword"><i className="bx bx-hide" /></a>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div id="loginError" role="alert" aria-live="polite" style={{ display: 'none', color: '#b02a37', background: '#fff0f0', padding: 10, borderRadius: 6, border: '1px solid #f5c2c7' }}>
                                                            Invalid email or password.
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-check form-switch">
                                                            <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" />
                                                            <label className="form-check-label" htmlFor="flexSwitchCheckChecked">Remember Me</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 text-end">
                                                        <a href="/auth-cover-forgot-password">Forgot Password?</a>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="d-grid">
                                                            <button type="submit" className="btn btn-primary" id="signInBtn">Sign
                                                                in</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AuthCoverSignin